import { Tooltip } from 'antd';
import cn from 'classnames';
import * as React from 'react';

import { ColumnsIconType } from 'entities/TableColumn';

import s from './Tooltips.module.scss';
import { TOOLTIP_MAP } from './config';

export type TooltipsProps = {
  className?: string;
  icons: ColumnsIconType[];
};

const Tooltips: React.FC<TooltipsProps> = ({ className, icons }) => {
  return (
    <span className={cn(className, s.tooltips)}>
      {icons
        // если добавят новый тип, который ещё не поддерживается фронтом
        .filter(({ kind }) => Boolean(TOOLTIP_MAP[kind]))
        .map(({ kind }) => {
          const { text, Icon } = TOOLTIP_MAP[kind];

          return (
            <Tooltip key={kind} title={text} placement="right">
              <span
                className={cn(
                  s.tooltips__item,
                  s[`tooltips__item_view_${kind}`]
                )}
              >
                <Icon />
              </span>
            </Tooltip>
          );
        })}
    </span>
  );
};

export default React.memo(Tooltips);
